











import Vue from 'vue';
import richiedenteEdit from '@/components/commands/RichiedenteEdit.vue';

export default Vue.extend({
    components: { richiedenteEdit },
    methods: {
        close() {
            this.$router.push({
                name: 'RichiedenteList',
            });
        },
    },
});
